import BasePageFilter from "@/domains/BasePageFilter/BasePageFilter";
import Person    from "@/domains/Persons/Person";
import Core from '@/core/Core';

class DemandsV2PageFilter extends BasePageFilter {
  static Events = {
    Updated: 'demands-v2-page-filter:updated',
  } as const;

  protected storageKey = 'filters:demands-v2';

  private _isMine: boolean;

  responsible: Person;

  get isMine(): boolean {
    return this._isMine;
  }

  set isMine(value: boolean) {
    this._isMine = value;

    if (value === true) {
      this.responsible = Core.currentUser;
    } else {
      this.responsible = undefined;
    }
  }

  reset(): void {
    this.responsible = undefined;
  }

  protected deserialize(json: string): void {
    const parsed = JSON.parse(json);
    this.responsible = Core.utils.hydrate(parsed.responsible, Person.fromServer);
  }

  getRequestParams(): Record<string, any> {
    const params: any = {};

    if (this.responsible?.id) params.responsible = { id: this.responsible.id };

    return params;
  }
}

export default DemandsV2PageFilter;
